namespace $.$$ {
	export class $shm_hitalama_map_widget_float_form_edit extends $.$shm_hitalama_map_widget_float_form_edit {

		@ $mol_mem
		form() {
			return this.widget().Form_edit()?.remote()!
		}

	}
}
